<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,7C11,7,7.41,7,7.41,7C7.41,7,8.7,5.71,8.7,5.71C8.89,5.53,9,5.28,9,5C9,4.45,8.55,4,8,4C7.72,4,7.47,4.11,7.29,4.29C7.29,4.29,4.29,7.29,4.29,7.29C4.11,7.47,4,7.72,4,8C4,8.28,4.11,8.53,4.29,8.71C4.29,8.71,7.29,11.71,7.29,11.71C7.47,11.89,7.72,12,8,12C8.55,12,9,11.55,9,11C9,10.72,8.89,10.47,8.71,10.29C8.71,10.29,7.41,9,7.41,9C7.41,9,11,9,11,9C11.55,9,12,8.55,12,8C12,7.45,11.55,7,11,7C11,7,11,7,11,7ZM8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM8,14C4.69,14,2,11.31,2,8C2,4.69,4.69,2,8,2C11.31,2,14,4.69,14,8C14,11.31,11.31,14,8,14C8,14,8,14,8,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CircleArrowLeft',
} as DefineComponent
</script>
